import * as React from "react"

interface LoaderProps {
  size?: number
  text?: string
}

export const AiLoadingSpinner: React.FC<LoaderProps> = ({
  size = 180,
  text = "",
}) => {
  // Spinner-specific yellow colors (not using brand chart colors)
  const yellow1 = `hsl(var(--chart-1))` // Primary yellow
  const yellow2 = `hsl(var(--chart-2))` // Saturated yellow
  const yellow3 = `hsl(var(--chart-4))` // Light yellow
  const grey = `hsl(var(--chart-5))` // Grey for depth/contrast

  return (
    <>
      <div
        className="relative flex select-none items-center justify-center"
        style={{
          width: size,
          height: size,
        }}
      >
        <span className="dark:text-gray-800 inline-block text-white opacity-80">
          {text}
        </span>

        <div className="animate-loaderCircle absolute inset-0 rounded-full"></div>
      </div>

      <style>{`
        @keyframes loaderCircle {
          0% {
            transform: rotate(90deg);
            box-shadow:
              0 6px 12px 0 ${yellow1} inset,
              0 12px 18px 0 ${yellow1} inset,
              0 36px 36px 0 ${grey} inset;
          }
          50% {
            transform: rotate(270deg);
            box-shadow:
              0 6px 12px 0 ${yellow3} inset,
              0 12px 6px 0 ${yellow1} inset,
              0 24px 36px 0 ${yellow2} inset;
          }
          100% {
            transform: rotate(450deg);
            box-shadow:
              0 6px 12px 0 ${yellow1} inset,
              0 12px 18px 0 ${yellow1} inset,
              0 36px 36px 0 ${grey} inset;
          }
        }

        @keyframes loaderLetter {
          0%,
          100% {
            opacity: 0.4;
            transform: translateY(0);
          }
          20% {
            opacity: 1;
            transform: scale(1.15);
          }
          40% {
            opacity: 0.7;
            transform: translateY(0);
          }
        }

        .animate-loaderCircle {
          animation: loaderCircle 5s linear infinite;
        }

        .animate-loaderLetter {
          animation: loaderLetter 3s infinite;
        }

        @media (prefers-color-scheme: dark) {
          .animate-loaderCircle {
            box-shadow:
              0 6px 12px 0 ${yellow1} inset,
              0 12px 18px 0 ${yellow1} inset,
              0 36px 36px 0 ${grey} inset;
          }
        }
      `}</style>
    </>
  )
}
